type TabItem = {
  showContent: boolean;
  showResults: boolean;
  showChallenges: boolean;
};

const allTabs: TabItem = {
  showContent: true,
  showResults: true,
  showChallenges: true,
};

const tabsWithoutChallenges: TabItem = {
  showContent: true,
  showResults: true,
  showChallenges: false,
};

export type LibraryItem = {
  code: string;
  tabs: TabItem;
};

export const naviagtionItems = {
  library: {
    title: 'nav.pages.library',
    code: 'library',
    auth: true,
    items: [
      {
        code: 'for-you',
        tabs: undefined,
      },
      {
        code: 'physical-wellbeing',
        tabs: tabsWithoutChallenges,
      },
      {
        code: 'movement',
        tabs: allTabs,
      },
      {
        code: 'sleep-&-rest',
        tabs: tabsWithoutChallenges,
      },
      {
        code: 'mental-wellbeing',
        tabs: allTabs,
      },
      {
        code: 'financial-wellbeing',
        tabs: tabsWithoutChallenges,
      },
      {
        code: 'nutrition',
        tabs: tabsWithoutChallenges,
      },
      {
        code: 'hydration-&-alcohol',
        tabs: allTabs,
      },
      {
        code: 'work-&-productivity',
        tabs: tabsWithoutChallenges,
      },
      {
        code: 'energy',
        tabs: tabsWithoutChallenges,
      },
    ],
  },
  goals: {
    title: 'nav.pages.goals',
    code: 'goals',
    auth: true,
  },
  explore: {
    title: 'nav.pages.explore',
    code: 'explore',
    auth: true,
  },
  support: {
    title: 'nav.pages.support',
    code: 'support',
    auth: true,
  },
  profile: {
    title: 'nav.pages.profile',
    code: 'profile',
    auth: true,
  },
};
